import React from 'react';
import ReactDOM from 'react-dom';

import TagManager from 'react-gtm-module';

import { datadogRum } from '@datadog/browser-rum';

// import actions from './actions/index';
import Router from './routes';
import store from './store';
import config from './config';

const tagManagerArgs = {
  gtmId: config.gtmID,
};

TagManager.initialize(tagManagerArgs);

datadogRum.init({
  applicationId: '8c6118ab-6ca9-4303-856b-d4477a0204b1',
  clientToken: 'pube7dafcf6a7dee61d5eb8ba5080838d62',
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'us5.datadoghq.com',
  service: 'admin-v1',
  env: '<ENV_NAME>',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: 'mask-user-input',
});

function render() {
  ReactDOM.render(<Router />, document.getElementById('root'));
}

async function start() {
  store.set({
    category_byId: {},
    category_queries: {},
    product_queries: {},
    product_byId: {},
  });
  // const env = process.env.REACT_APP_API_URL || {};

  // const location = window.location.host;

  // await actions.token.getCredentials(env.REACT_APP_DOMAIN || 'localhost:3000');
  // await actions.token.getSettings();
  // await actions.category.getCategory();

  render();
}

start();
